import * as researcherFormType from './researcherFormTypes'
import useResearcherForm from './useResearcherForm'
import MyTextfield from '../../../../control/textfield/textfield'
import Autocomplete from '../../../../control/autocomplete/autocomplete'
import {
    validateEmail,
    validatePhone,
    validateMobilePhone,
    validateEN,
    validateTextLength30,
} from '../../../../utilities/validate'
import { Button, Grid, IconButton } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import React from 'react'
import Checkbox from '../../../../control/checkbox/checkbox'
import { useForm, useFormState } from 'react-final-form'
import useTranslate from '../../../../i18n/useTranslate'
import MyAccordion from '../../../../control/accordion/accordion'
import Select from '../../../../control/select/select'
import Tooltip from '../../../../control/tooltip/tooltip'
import { Add, InfoOutlined } from '@material-ui/icons'
import { FieldArray } from 'react-final-form-arrays'

//View
const ResearchFormView = (props: researcherFormType.ResearcherFormView) => {
    const {
        headerLabel,
        hideAccordion = false,
        researcherType,
        disabled = false,
        titleNameList,
        academicPositionList,
        educationLevelLut,
        isNeedEditForm,
        addResearcher,
    } = props
    const classes = useStyles({})
    const translate = useTranslate()

    const form = useForm()
    const { values } = useFormState({ subscription: { values: true } })

    const renderElement = () => (
        <Grid container item justify="flex-start" spacing={2}>
            <Grid item md={12} style={{ textAlign: 'left' }}>
                <Button
                    variant="outlined"
                    color="primary"
                    startIcon={<Add />}
                    onClick={() => addResearcher()}
                    disabled={disabled || !isNeedEditForm}
                >
                    {translate.get('BUTTON.ADD_RESEARCHER')}
                </Button>
            </Grid>
            <FieldArray name="coResearcher">
                {({ fields }) =>
                    !fields.length ? (
                        <Grid container item xs={12} alignItems="center" spacing={1}>
                            <Grid item xs={12}>
                                <Typography variant="body2" color="textSecondary">
                                    {translate.get('LABEL.NOT_FOUND_RESEARCHER')}
                                </Typography>
                            </Grid>
                        </Grid>
                    ) : (
                        fields.map((namePath, idx) => {
                            const r = values?.coResearcher?.[idx] ?? {}
                            const titleName = r?.titleName
                            const academicPosition = r?.academicPosition
                            const isShowEducationLevel =
                                r?.researcherType?.value.toString() === researcherFormType.ResearcherType.student
                            const isShowAcademicPosition =
                                r?.researcherType?.value.toString() !== researcherFormType.ResearcherType.student
                            const canRemove = (fields.length ?? 0) > 1

                            const resetTitleOthers = () => {
                                form.resetFieldState(`coResearcher[${idx}].otherTitleNameTH`)
                                form.resetFieldState(`coResearcher[${idx}].otherTitleNameEN`)
                            }
                            const resetAcademicPositionOthers = () => {
                                form.resetFieldState(`coResearcher[${idx}].otherAcademicPositionTH`)
                                form.resetFieldState(`coResearcher[${idx}].otherAcademicPositionEN`)
                            }

                            return (
                                <Grid key={namePath} container item spacing={2}>
                                    <Grid item xs={12} md={12} lg={12}>
                                        <Typography className={classes.line}></Typography>
                                    </Grid>
                                    <Grid
                                        item
                                        xs={12}
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'space-between',
                                        }}
                                    >
                                        <Typography variant="subtitle1">
                                            {idx === 0 ?
                                            translate.get('LABEL.RESEARCHER_MAIN', [String(idx + 1)])
                                            : translate.get('LABEL.RESEARCHER_N', [String(idx + 1)]) 
                                            }
                                        </Typography>
                                        {canRemove && (
                                            <Button
                                                variant="contained"
                                                color="secondary"
                                                onClick={() => form.mutators.remove?.('coResearcher', idx)}
                                                disabled={disabled || !isNeedEditForm || idx < 1}
                                            >
                                                {translate.get('BUTTON.DELETE')}
                                            </Button>
                                        )}
                                    </Grid>

                                    <Grid item xs={12}>
                                        <Typography className={classes.fontDetail}>
                                            {translate.get('LABEL.LABEL_02')}
                                        </Typography>
                                    </Grid>

                                    <Grid item xs={12}>
                                        <Autocomplete
                                            name={`${namePath}.researcherType`}
                                            materialInputProps={{
                                                label: translate.get('LABEL.RESEARCHER_TYPE'),
                                                placeholder: translate.get('LABEL.PLEASE_SELECT'),
                                                disabled: disabled || !isNeedEditForm,
                                            }}
                                            options={researcherType}
                                            required
                                        />
                                    </Grid>
                                    {isShowEducationLevel && (
                                        <Grid item xs={12}>
                                            <Autocomplete
                                                name={`${namePath}.educationLevel`}
                                                materialInputProps={{
                                                    label: translate.get('LABEL.EDUCATION_LEVEL'),
                                                    placeholder: translate.get('LABEL.PLEASE_SELECT'),
                                                    disabled: disabled || !isNeedEditForm,
                                                }}
                                                options={educationLevelLut}
                                                required
                                            />
                                        </Grid>
                                    )}
                                    <Grid item xs={12} sm={12} md={12} lg={4}>
                                        <Select
                                            name={`${namePath}.titleName`}
                                            option={titleNameList}
                                            label={translate.get('LABEL.NAME_TITLE')}
                                            placeholder={translate.get('LABEL.NAME_TITLE')}
                                            size="small"
                                            disabled={disabled || !isNeedEditForm}
                                            defaultValue={r.titleName ?? null}
                                            onChangeSelect={(newVal) => {
                                                if (String(newVal ?? '') !== String(titleName ?? '')) {
                                                    resetTitleOthers()
                                                }
                                            }}
                                            icon={
                                                <Tooltip title={translate.get('MESSAGE.M025')}>
                                                    <IconButton size="small">
                                                        <InfoOutlined style={{ fontSize: '18px' }} />
                                                    </IconButton>
                                                </Tooltip>
                                            }
                                            required
                                        />
                                    </Grid>

                                    <Grid item xs={12} sm={6} md={6} lg={4}>
                                        <MyTextfield
                                            key={`${titleName}-otherTitleNameTH-${idx}`}
                                            name={`${namePath}.otherTitleNameTH`}
                                            materialInputProps={{
                                                disabled:
                                                    (titleName === '5' ? false : true) || disabled || !isNeedEditForm,
                                                label: `${translate.get('LABEL.NAME_OTHER_TITLE')} (${translate.get(
                                                    'LABEL.THAI',
                                                )})`,
                                                placeholder: `${translate.get(
                                                    'LABEL.NAME_OTHER_TITLE',
                                                )} (${translate.get('LABEL.THAI')}) ${translate.get(
                                                    'LABEL.CAN_BE_FILL_ENG',
                                                )}`,
                                                size: 'small',
                                            }}
                                            maxLength={250}
                                            //required={titleName === '5'}
                                            fontSize={16}
                                        />
                                    </Grid>

                                    <Grid item xs={12} sm={6} md={6} lg={4}>
                                        <MyTextfield
                                            key={`${titleName}-otherTitleNameEN-${idx}`}
                                            name={`${namePath}.otherTitleNameEN`}
                                            materialInputProps={{
                                                disabled:
                                                    (titleName === '5' ? false : true) || disabled || !isNeedEditForm,
                                                label: `${translate.get('LABEL.NAME_OTHER_TITLE')} (${translate.get(
                                                    'LABEL.ENG',
                                                )})`,
                                                placeholder: `${translate.get(
                                                    'LABEL.NAME_OTHER_TITLE',
                                                )} (${translate.get('LABEL.ENG')})`,
                                                size: 'small',
                                            }}
                                            maxLength={250}
                                            //required={titleName === '5'}
                                            fontSize={16}
                                        />
                                    </Grid>

                                    {isShowAcademicPosition && (
                                        <>
                                            <Grid item xs={12}>
                                                <Checkbox
                                                    name={`${namePath}.isDr`}
                                                    label={translate.get('LABEL.IS_DOCTOR')}
                                                    disabled={disabled || !isNeedEditForm}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={12} md={12} lg={4}>
                                                <Select
                                                    name={`${namePath}.academicPosition`}
                                                    option={academicPositionList}
                                                    label={translate.get('LABEL.ACADEMIC_TITLE')}
                                                    placeholder={translate.get('LABEL.ACADEMIC_TITLE')}
                                                    size="small"
                                                    disabled={disabled || !isNeedEditForm}
                                                    defaultValue={r.academicPosition ?? null}
                                                    onChangeSelect={(newVal) => {
                                                        if (String(newVal ?? '') !== String(academicPosition ?? '')) {
                                                            resetAcademicPositionOthers()
                                                        }
                                                    }}
                                                    icon={
                                                        <Tooltip
                                                            title={translate.get('MESSAGE.M024', [
                                                                translate.get('LABEL.IS_DOCTOR'),
                                                            ])}
                                                        >
                                                            <IconButton size="small">
                                                                <InfoOutlined style={{ fontSize: '18px' }} />
                                                            </IconButton>
                                                        </Tooltip>
                                                    }
                                                    required
                                                />
                                            </Grid>

                                            <Grid item xs={12} sm={6} md={6} lg={4}>
                                                <MyTextfield
                                                    key={`${academicPosition}-otherAcademicPositionTH-${idx}`}
                                                    name={`${namePath}.otherAcademicPositionTH`}
                                                    materialInputProps={{
                                                        disabled:
                                                            (academicPosition === '6' ? false : true) ||
                                                            disabled ||
                                                            !isNeedEditForm,
                                                        label: `${translate.get(
                                                            'LABEL.ACADEMIC_OTHER_TITLE',
                                                        )} (${translate.get('LABEL.THAI')})`,
                                                        placeholder: `${translate.get(
                                                            'LABEL.ACADEMIC_OTHER_TITLE',
                                                        )} (${translate.get('LABEL.THAI')}) ${translate.get(
                                                            'LABEL.CAN_BE_FILL_ENG',
                                                        )}`,
                                                        size: 'small',
                                                    }}
                                                    maxLength={250}
                                                    //required={academicPosition === '6'}
                                                    fontSize={14}
                                                />
                                            </Grid>

                                            <Grid item xs={12} sm={6} md={6} lg={4}>
                                                <MyTextfield
                                                    key={`${academicPosition}-otherAcademicPositionEN-${idx}`}
                                                    name={`${namePath}.otherAcademicPositionEN`}
                                                    materialInputProps={{
                                                        disabled:
                                                            (academicPosition === '6' ? false : true) ||
                                                            disabled ||
                                                            !isNeedEditForm,
                                                        label: `${translate.get(
                                                            'LABEL.ACADEMIC_OTHER_TITLE',
                                                        )} (${translate.get('LABEL.ENG')})`,
                                                        placeholder: `${translate.get(
                                                            'LABEL.ACADEMIC_OTHER_TITLE',
                                                        )} (${translate.get('LABEL.ENG')})`,
                                                        size: 'small',
                                                    }}
                                                    maxLength={250}
                                                    //required={academicPosition === '6'}
                                                    fontSize={14}
                                                />
                                            </Grid>
                                        </>
                                    )}

                                    <Grid item xs={12} md={6} lg={6}>
                                        <MyTextfield
                                            name={`${namePath}.nameTH`}
                                            materialInputProps={{
                                                disabled: disabled || !isNeedEditForm,
                                                label: `${translate.get('LABEL.RESEARCHER_FL_NAME')} (${translate.get(
                                                    'LABEL.THAI',
                                                )}) ${translate.get('LABEL.PLEASE_FILL_DATA')}`,
                                                placeholder: `${translate.get(
                                                    'LABEL.RESEARCHER_FL_NAME',
                                                )} (${translate.get('LABEL.THAI')}) ${translate.get(
                                                    'LABEL.CAN_BE_FILL_ENG',
                                                )}`,
                                                size: 'small',
                                            }}
                                            maxLength={250}
                                            required
                                        />
                                    </Grid>

                                    <Grid item xs={12} md={6} lg={6}>
                                        <MyTextfield
                                            name={`${namePath}.nameEN`}
                                            materialInputProps={{
                                                disabled: disabled || !isNeedEditForm,
                                                label: `${translate.get('LABEL.RESEARCHER_FL_NAME')} (${translate.get(
                                                    'LABEL.ENG',
                                                )})`,
                                                placeholder: `${translate.get(
                                                    'LABEL.RESEARCHER_FL_NAME',
                                                )} (${translate.get('LABEL.ENG')})`,
                                                size: 'small',
                                            }}
                                            validates={[validateEN(translate.get('MESSAGE.M002'))]}
                                            maxLength={250}
                                            required
                                        />
                                    </Grid>

                                    <Grid item xs={12} md={6} lg={6}>
                                        <MyTextfield
                                            name={`${namePath}.homePhone`}
                                            materialInputProps={{
                                                disabled: disabled || !isNeedEditForm,
                                                label: translate.get('LABEL.TELEPHONE_NUMBER'),
                                                placeholder: translate.get('LABEL.TELEPHONE_NUMBER'),
                                                size: 'small',
                                            }}
                                            validates={[validatePhone(translate.get('MESSAGE.M003'))]}
                                        />
                                    </Grid>

                                    <Grid item xs={12} md={6} lg={6}>
                                        <MyTextfield
                                            name={`${namePath}.fax`}
                                            materialInputProps={{
                                                disabled: disabled || !isNeedEditForm,
                                                label: translate.get('LABEL.FAX'),
                                                placeholder: translate.get('LABEL.FAX'),
                                                size: 'small',
                                            }}
                                            validates={[validateTextLength30]}
                                            maxLength={50}
                                        />
                                    </Grid>

                                    <Grid item xs={12} md={6} lg={6}>
                                        <MyTextfield
                                            name={`${namePath}.mobilePhone`}
                                            materialInputProps={{
                                                disabled: disabled || !isNeedEditForm,
                                                label: translate.get('LABEL.MOBILE_PHONE_NO'),
                                                placeholder: translate.get('LABEL.MOBILE_PHONE_NO'),
                                                size: 'small',
                                            }}
                                            validates={[validateMobilePhone(translate.get('MESSAGE.M004'))]}
                                            required
                                        />
                                    </Grid>

                                    <Grid item xs={12} md={6} lg={6}>
                                        <MyTextfield
                                            name={`${namePath}.email`}
                                            materialInputProps={{
                                                disabled: disabled || !isNeedEditForm,
                                                label: translate.get('LABEL.EMAIL'),
                                                placeholder: '',
                                                size: 'small',
                                            }}
                                            validates={[validateEmail(translate.get('MESSAGE.M017'))]}
                                            required
                                        />
                                    </Grid>
                                </Grid>
                            )
                        })
                    )
                }
            </FieldArray>
        </Grid>
    )
    return (
        <React.Fragment>
            {hideAccordion ? (
                renderElement()
            ) : (
                <MyAccordion title={headerLabel ?? translate.get('LABEL.RESEARCHER_DETAIL')}>
                    {renderElement()}
                </MyAccordion>
            )}
        </React.Fragment>
    )
}
//Controller
const ResearcherForm = (props: researcherFormType.ResearcherFormType) => {
    // const {​ disabled }​ = props
    const createFormModel = useResearcherForm(props)
    return <ResearchFormView {...createFormModel} {...props} />
}
export default ResearcherForm

const useStyles = makeStyles((theme) => ({
    fontDetail: {
        fontSize: '14px',
        color: '#bfbfbf',
    },
    line: {
        borderTop: '1px solid #c7c7c7',
        marginTop: '12px',
        marginBottom: '16px',
    },
}))
